// 登录到最慧学
import request from '../utils/request'

export function listProject (pageNum, pageSize) {
  return request({
    url: '/zhx/api/wrongScan/getWrongScanList?pageNum=' + pageNum + '&pageSize=' + pageSize,
    method: 'get'
  })
}

export function getProject (wrongScanId, scanType) {
  return request({
    url: '/zhx/api/wrongScan/getWrongScanDetail?wrongScanId=' + wrongScanId + '&scanType=' + scanType + '&latexStyle=1',
    method: 'get'
  })
}

export function modifyQuestionCount (questionCountData) {
  let data = new FormData()
  data.append('questionCount', questionCountData)
  return request({
    url: '/zhx/api/wrongScan/modifyQuestionCount',
    method: 'post',
    headers: {
      // 设置提交数据格式
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    data: data
  })
}

export function modifyScanType (wrongScanId, scanType, hasSubCount) {
  let data = new FormData()
  data.append('wrongScanId', wrongScanId)
  data.append('scanType', scanType)
  data.append('hasSubCount', hasSubCount)
  return request({
    url: '/zhx/api/wrongScan/modifyScanType',
    method: 'post',
    headers: {
      // 设置提交数据格式
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/apis/projectApi.js